(function () {
  'use strict';
  
  /**
   * @ngdoc service
   * @name tracker.factory:Tracker
   *
   * @description
   *
   */
  angular
    .module('vctracker')
    .factory('Trackervalue', Trackervalue);


  Trackervalue.$inject = ['restmod'];
  function Trackervalue(restmod) {
    return restmod.model('/routes/trackervalues').mix({
      created: {
        init: function () {
          return moment().toISOString();
        }
      },
      active: {init: true},
      $extend: {
        Model: {
          $searchahead: function (_params) {
            return this.$collection().$decorate({
              'before-request': function (_req) {
                _req.method = 'GET';
                _req.url = '/routes/trackervalues/searchahead';
              }
            }, function () {
              return this.$fetch(_params);
            });
          },
          $searchBy: function (key, val) {
            return $search({key, val});
          }
        } // Model
      }// extend
    });
  }
  
// klammerfriedhof
}());
